export default {
      id: "viewList-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#viewList-usage",
      toString: function () {
        return this.url;
      }
    }